"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _constants = require("@xe/constants");

var _textStyles = _interopRequireDefault(require("./text-styles"));

var _default = "\n  @charset \"utf-8\";\n  @import url(\"".concat(_constants.TYPOGRAPHY.fontFaceUrl, "\");\n\n  *,\n  *::before,\n  *::after {\n    box-sizing: border-box;\n  }\n\n  // Firefox 2-61\n  ::moz-selection {\n    background: #b5d7fd;\n  }\n\n  ::selection {\n    background: #b5d7fd;\n  }\n\n  button, html input[type=\"button\"], input[type=\"reset\"], input[type=\"submit\"] {\n    -webkit-appearance: button;\n    cursor: pointer;\n  }\n\n  button[disabled], html input[disabled] {\n    cursor: default;\n  }\n\n  ").concat(_textStyles["default"], "\n");

exports["default"] = _default;